
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { mergeStyleSets } from '@uifabric/merge-styles';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import Text from '../../common/client/components/Text';

//import { GET_PARAMS_ACTION_TYPE } from '../../sagas/app';
import { CREATE_PROJECT_ACTION_TYPE } from '../../sagas/project';
import {
    CLEAR_PROJECT_LIST_ACTION_TYPE,
    GET_PROJECT_LIST_ACTION_TYPE
} from '../../sagas/projectList';

import { getVersionString } from '../../utils';
import theme from '../common/theme';
import Loading from '../common/Loading';
import ContentNavigation from '../common/ContentNavigation';
import LoginInfo from '../auth/LoginInfo';

import ProjectList from './ProjectList';
import DialogCreateProject from '../DialogCreateProject';

const classNames = mergeStyleSets({
    root: {
        ...theme.styles.flexColumnGrow,
        minHeight: 0,
        alignItems: 'center',
        justifyContent: 'center'
    },
    contentNavigation: {
        width: '800px',
        paddingTop: '8px',
        paddingBottom: '8px',
        marginBottom: '8px',
        borderBottom: '1px solid #cccccc'
    },
    title: {
        ...theme.styles.flexColumn,
        minHeight: 0,
        fontSize: '32px',
        fontWeight: 'bold',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0px 0px 24px 0px'
    },
    content: {
        ...theme.styles.flexColumnGrow,
        minHeight: 0,
        width: '800px'
    },
    footer: {
    }
});

class ProjectListPage extends Component {

    componentDidMount() {
        this.props.clearProjectList();
        this.checkFetchParams();
        this.checkFetchProjectList();
    }

    componentDidUpdate(prevProps, prevState) {
        this.checkFetchProjectList();
    }

    checkFetchParams() {
        if (!this.props.params) {
            //this.props.getParams();
        }
    }

    checkFetchProjectList() {
        const notLoaded = (!this.props.projectList.loaded && !this.props.projectList.loading && !this.props.authLoading);
        const error = (this.props.projectList.error)
        if (notLoaded && !error)  {
            this.props.getProjectList(this.props.token);
        }
    }

    getIsUserLogged() {
        return (!!this.props.token);
    }

    getNavigationItems() {
        return [
            {title: 'Úvodní strana', path: '#/'},
            {title: 'Seznam projektů', path: '#/projectList'}
        ];
    }

    handleCreateClick = async () => {
        let projectParams = await DialogCreateProject.show();
        if (projectParams) {
            this.props.createProject(this.props.token, projectParams);
        }
    }

    handleProjectClick = (project) => {
        this.props.history.push(`/projectview/${project.id}`);
    }

    handleRefreshClick = () => {
        this.props.getProjectList(this.props.token);
    }

    render() {
        return (
            <Stack verticalFill className={classNames.root}>
                <div className={classNames.contentNavigation}>
                    <Stack horizontal>
                        <Stack.Item grow>
                            <ContentNavigation
                                items={this.getNavigationItems()}
                                paths={[]}
                            />
                        </Stack.Item>
                        <LoginInfo />
                    </Stack>
                </div>
                <Stack.Item grow className={classNames.content}>
                    {(/*this.props.params &&*/ this.props.projectList.loaded)
                        ? <ProjectList
                            projectList={this.props.projectList.data.projectList}
                            isUserLogged={this.getIsUserLogged()}
                            onCreateClick={this.handleCreateClick}
                            onProjectClick={this.handleProjectClick}
                            onRefreshClick={this.handleRefreshClick}
                        />
                        : <Loading />
                    }
                </Stack.Item>
                <div className={classNames.footer}>
                    <Text small color="#999999">Verze: {getVersionString()}</Text>
                </div>
            </Stack>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        clearProjectList: (token) => dispatch({type: CLEAR_PROJECT_LIST_ACTION_TYPE, token}),
        createProject: (token, params) => dispatch({type: CREATE_PROJECT_ACTION_TYPE.DEFAULT, token, params}),
        getProjectList: (token) => dispatch({type: GET_PROJECT_LIST_ACTION_TYPE.DEFAULT, token}),
        //getParams: () => dispatch({type: GET_PARAMS_ACTION_TYPE.DEFAULT})
    };
}

function mapStateToProps(state, ownProps) {
    return {
        //params: state.app.params,
        projectList: state.projectList,
        token: state.auth.data ? state.auth.data.user.token : null,
        authLoading: state.auth.loading
    };
}

const ConnectedProjectListPage = connect(mapStateToProps, mapDispatchToProps)(ProjectListPage);

export default ConnectedProjectListPage;
